import { Globals } from "./Globals.js";
import { QRFC } from "./QRFC";

export class QPollTalentRFC extends QRFC {
  constructor() {
    super();
  }

  InitPollTalent(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, planID) {
    this.AddParameter("data", planID);
    this.AddParameter("mode", "polltalent");
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, planMgr) {
    var r = JSON.parse(response);
    var success = r["success"];
    if (!success) {
      planMgr.PlanAlert(r["message"]);
      this.fWSMgr.ChangeDoc("Viewer");
      return;
    }
    planMgr.SetTalentPoolHash(r["talentPoolmd5"]);
    planMgr.UpdateTalentPool(r["data"]);
    planMgr.UpdateContext();
    Globals._wsMgr.UpdateDocContext();
  }
}
